export const CANVAS_CONTENT_WIDTH = 740

// Layout constants (re-exported from styles/layoutStyles.ts for styled-component consumers)
export const CARD_WIDTH = CANVAS_CONTENT_WIDTH
export const SHEET_PADDING = 80
export const CANVAS_MIN_WIDTH = CARD_WIDTH + SHEET_PADDING
export const CHAT_MIN_WIDTH = 600
export const CHAT_DEFAULT_WIDTH_PERCENT = 35
export const LEFT_PANE_WIDTH_VAR = '--leftPaneWidth'
export const SHOW_ON_MAP_ZOOM = 13
